module.exports = __webpack_public_path__ + "static/media/ProcessMaker.e4fd0913.jpg";